import React from 'react';
import { motion } from 'framer-motion';

const faqs = [
  {
    q: "Quanto costa uno sgombero?",
    a: "Il prezzo dipende da volume, tipo di materiali, piano e accessibilità. Facciamo un preventivo su misura, gratuito e senza impegno: bastano poche foto su WhatsApp."
  },
  {
    q: "In quali zone operate?",
    a: "A Varese, Como, Bergamo, Lecco e in tutta la Brianza, in un raggio di circa 100 km da Limbiate."
  },
  {
    q: "In quanto tempo intervenite?",
    a: "In tempi brevi e, per le urgenze, spesso entro 24-48 ore."
  },
  {
    q: "Vi occupate anche dello smaltimento?",
    a: "Sì, smaltiamo tutto in discariche e piattaforme autorizzate, a norma di legge nel rispetto dell'ambiente."
  },
  {
    q: "Fate anche traslochi?",
    a: "Certamente. Offriamo un servizio completo: imballaggio, smontaggio, trasporto e rimontaggio."
  }
];

export default function FAQ() {
  return (
    <section className="py-24 bg-[#080808] border-t border-white/5">
      <div className="container mx-auto px-5">
        <h2 className="text-4xl md:text-6xl font-display uppercase italic text-center mb-16">
          Domande <span className="text-maaich-lime">Frequenti</span>
        </h2>

        <div className="max-w-4xl mx-auto grid gap-6">
          {faqs.map((faq, idx) => (
            <motion.div 
              key={idx}
              className="bg-maaich-black border border-white/10 p-6 md:p-8"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl md:text-2xl font-display uppercase italic text-maaich-lime mb-4">{faq.q}</h3>
              <p className="text-white/60 font-body text-base md:text-lg leading-relaxed">{faq.a}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}